import { render, staticRenderFns } from "./UserAssetListTable.vue?vue&type=template&id=a4148612&"
import script from "./UserAssetListTable.vue?vue&type=script&lang=js&"
export * from "./UserAssetListTable.vue?vue&type=script&lang=js&"
import style0 from "./UserAssetListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports